/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ServerDefs from '../server/defs.defs.js'

const $nsid = 'com.atproto.admin.defs'

export { $nsid }

type StatusAttr = {
  $type?: 'com.atproto.admin.defs#statusAttr'
  applied: boolean
  ref?: string
}

export type { StatusAttr }

const statusAttr = l.typedObject<StatusAttr>(
  $nsid,
  'statusAttr',
  l.object({ applied: l.boolean(), ref: l.optional(l.string()) }),
)

export { statusAttr }

type AccountView = {
  $type?: 'com.atproto.admin.defs#accountView'
  did: l.DidString
  handle: l.HandleString
  email?: string
  relatedRecords?: l.LexMap[]
  indexedAt: l.DatetimeString
  invitedBy?: ServerDefs.InviteCode
  invites?: ServerDefs.InviteCode[]
  invitesDisabled?: boolean
  emailConfirmedAt?: l.DatetimeString
  inviteNote?: string
  deactivatedAt?: l.DatetimeString
  threatSignatures?: ThreatSignature[]
}

export type { AccountView }

const accountView = l.typedObject<AccountView>(
  $nsid,
  'accountView',
  l.object({
    did: l.string({ format: 'did' }),
    handle: l.string({ format: 'handle' }),
    email: l.optional(l.string()),
    relatedRecords: l.optional(l.array(l.lexMap())),
    indexedAt: l.string({ format: 'datetime' }),
    invitedBy: l.optional(
      l.ref<ServerDefs.InviteCode>((() => ServerDefs.inviteCode) as any),
    ),
    invites: l.optional(
      l.array(
        l.ref<ServerDefs.InviteCode>((() => ServerDefs.inviteCode) as any),
      ),
    ),
    invitesDisabled: l.optional(l.boolean()),
    emailConfirmedAt: l.optional(l.string({ format: 'datetime' })),
    inviteNote: l.optional(l.string()),
    deactivatedAt: l.optional(l.string({ format: 'datetime' })),
    threatSignatures: l.optional(
      l.array(l.ref<ThreatSignature>((() => threatSignature) as any)),
    ),
  }),
)

export { accountView }

type RepoRef = { $type?: 'com.atproto.admin.defs#repoRef'; did: l.DidString }

export type { RepoRef }

const repoRef = l.typedObject<RepoRef>(
  $nsid,
  'repoRef',
  l.object({ did: l.string({ format: 'did' }) }),
)

export { repoRef }

type RepoBlobRef = {
  $type?: 'com.atproto.admin.defs#repoBlobRef'
  did: l.DidString
  cid: l.CidString
  recordUri?: l.AtUriString
}

export type { RepoBlobRef }

const repoBlobRef = l.typedObject<RepoBlobRef>(
  $nsid,
  'repoBlobRef',
  l.object({
    did: l.string({ format: 'did' }),
    cid: l.string({ format: 'cid' }),
    recordUri: l.optional(l.string({ format: 'at-uri' })),
  }),
)

export { repoBlobRef }

type ThreatSignature = {
  $type?: 'com.atproto.admin.defs#threatSignature'
  property: string
  value: string
}

export type { ThreatSignature }

const threatSignature = l.typedObject<ThreatSignature>(
  $nsid,
  'threatSignature',
  l.object({ property: l.string(), value: l.string() }),
)

export { threatSignature }
